import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { firstValueFrom, filter, take, timeout } from 'rxjs';

/**
 * Auth guard that checks if user is authenticated.
 * Waits for Firebase Auth to initialize before checking auth state.
 */
export const authGuard: CanMatchFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if we have a quick sync answer
  if (authService.isLoggedIn) {
    return true;
  }

  // If auth is not yet initialized, wait for it
  if (!authService.authInitialized()) {
    try {
      // Wait for auth state to be determined (max 5 seconds)
      const user = await firstValueFrom(
        authService.authState$.pipe(
          // Skip the initial null and wait for actual state
          filter(() => authService.authInitialized()),
          take(1),
          timeout(5000)
        )
      );

      if (user) {
        return true;
      }
    } catch {
      // Timeout or error - treat as not authenticated
      console.warn('Auth state check timed out');
    }
  }

  // Not authenticated - redirect to login
  router.navigate(['/login']);
  return false;
};
